import PropTypes from 'prop-types'

import ItemLoader from './ItemLoader'

const AnalyticsItem = ({ icon, title, count, isLoading }) => {
  if (isLoading) {
    return <ItemLoader />
  }

  return (
    <div className="visitor-analytics__item">
      <div className="visitor-analytics__item-title-container">
        {icon}
        <span>{title}</span>
      </div>
      <div className="visitor-analytics__item-count">{count || '-'}</div>
    </div>
  )
}

AnalyticsItem.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
  isLoading: PropTypes.bool,
}

export default AnalyticsItem
